import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const WelcomeMessage: React.FC = () => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="flex items-center justify-center h-8 w-8 rounded-full bg-green-500 text-white">
            👋
          </div>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-green-800">
            Welcome, {user.name}!
          </h3>
          <div className="mt-2 text-sm text-green-700">
            {!user.isVerified ? (
              <p>
                Please check your email to verify your account. A verification email has been sent to{' '}
                <strong>{user.email}</strong>.
              </p>
            ) : (
              <p>
                Thank you for being part of Pakistan's progress. Explore our programs and opportunities!
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage;
